import "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import { getCookieByName as p } from "@ado/cookie-library";
import "../../../shared/data/csr/state/index2.js";
import { getLayout as m, setShowIpRedirectPrompt as n } from "../../../shared/data/layout/state/index.js";
import { BannerStyle as c } from "../../../shared/data/layout/state/index2.js";
import "../../../shared/data/location/state/index.js";
import "../../../shared/data/navigation/state/index2.js";
import "@ado/experiment-library";
import "../../../search/state/index2.js";
import { getUser as a } from "../../../shared/data/user/state/index2.js";
import "@ado/acs-standard-library";
import { defineComponent as s, defineAsyncComponent as d, computed as e } from "vue";
import u from "./index4.js";
import f from "./index5.js";
import { getJSONObjectFromCookie as y } from "../../../shared/libraries/cookie-handling/index.js";
const U = s({
  name: "Banner",
  components: {
    Header: u,
    Navigation: f,
    RedirectPrompt: d(
      () => import("../../../redirect_prompt/ui/components/index.js")
    )
  },
  props: {
    bannerStyle: {
      type: String,
      required: !0
    },
    config: {
      type: Object,
      required: !0
    },
    csr: {
      type: Object,
      required: !0
    },
    location: {
      type: Object,
      required: !0
    },
    menuCategories: {
      type: Array,
      default: () => []
    },
    showSearch: {
      type: Boolean,
      default: !0
    }
  },
  setup() {
    const t = e(() => a()), o = e(
      () => m().showIpRedirectPrompt
    ), r = c;
    if (p("ShowIpRedirectPrompt")) {
      const i = y("ShowIpRedirectPrompt", {
        RedirectToUrl: "",
        RedirectToCountryName: "",
        ShowPrompt: !1
      });
      n(i.ShowPrompt);
    }
    return {
      user: t,
      bannerStyles: r,
      showIpRedirectPrompt: o
    };
  }
});
export {
  U as default
};
//# sourceMappingURL=index2.js.map
